const Style = {

  base: 'relative block text-sm mb-2 uppercase',
  required: `after:text-red-500 after:ml-1 after:font-semibold after:content-['*']`

}

export default Style;